import React, { useState } from 'react'
import { IP } from "./../internalServer"
import { iconData } from '../iconData';
import PdfViewer from '../HwManagement/PdfViewer/PdfViewer';
import assets from '../assets/assets';
import MideaViewer from '../midea_viewer/MideaViewer';

function NoticeBoardPopUp({ setNoticeBoxOpen, noticeData }) {
    const [isClicked, setIsClicked] = useState(false);
    const [isError, setIsError] = useState(false);
    const [showPdfViewer, setShowPdfViewer] = useState(false)
    const [responseAttach, setResponseAttach] = useState();
    const [pedingSubDetail, setPedingSubDetail] = useState({
        pdfView: false,
    });
    // const handleRemovePdfVivwer = () => {
    //     setPedingSubDetail({
    //         ...pedingSubDetail,
    //         pdfView: false,
    //     });
    // };
    const handleClick = (attachment) => {
        setResponseAttach(attachment);
        setIsClicked(!isClicked);
    };
    const handleClickforpdf = (attachment) => {
        setResponseAttach(attachment)
    };
    return (
        <div className="successful_create_transprant_body">
            <div className="p-3 successful_notice_board_popup shadow relative">
                <img
                    style={{ position: "absolute", top: "0%", right: "0%", }}
                    src={assets.CrossIcon}
                    className="w-7 cursor-pointer"
                    alt="crossicon"
                    onClick={() => setNoticeBoxOpen(false)}
                />
                <div className="my-2 mt-3 noticeboardtext">
                    {noticeData?.notice}
                </div>
                <div className="content-header">
                    <div className="attachment">
                        <div style={{ display: "flex", gap: "10px", padding: "0px 10px", overflowY: "scroll" }}>
                            {noticeData?.attachments?.length > 0 ?
                                noticeData?.attachments?.map(
                                    (attachment, index) => (
                                        <div key={index}>
                                            {attachment.split(".").pop() !== "mp4" ? (
                                                <>
                                                    {attachment.split(".").pop() === "jpg" ||
                                                        attachment.split(".").pop() === "jpeg" ||
                                                        attachment.split(".").pop() === "JPEG" ||
                                                        attachment.split(".").pop() === "JPG" ||
                                                        attachment.split(".").pop() === "PNG" ||
                                                        attachment.split(".").pop() === "png" ? (
                                                        <img
                                                            style={{ cursor: "pointer" }}
                                                            className="mt-3 imageWidthAndHeight"
                                                            src={IP + attachment?.replace(/^\./, "")}
                                                            alt="Attachment"
                                                            onClick={() => {
                                                                if (!isError) {
                                                                    handleClick(attachment);
                                                                }
                                                            }}
                                                            onError={(e) => {
                                                                const extension = attachment?.match(/\.([^.]+)$/)?.[1];
                                                                const icon = iconData?.find((i) => i.extension === extension)?.icon;
                                                                // Replace the image source with fallback icon
                                                                e.target.src = icon
                                                                e.target.style.width = "80px";
                                                                e.target.style.height = "80px";
                                                                e.target.onerror = null;
                                                            }}
                                                        />
                                                    ) : (
                                                        <div
                                                            key={index}
                                                            onClick={() => setShowPdfViewer(true)}
                                                            className="mt-2"
                                                        >
                                                            <div className="d-flex pdfContainer gap-2 p-2 ">
                                                                <div className="d-flex align-items-center">
                                                                    <img
                                                                        className="extention_icon"
                                                                        src={`${iconData?.find(
                                                                            (i) =>
                                                                                i.extension ===
                                                                                attachment?.match(/\.([^.]+)$/)[1]
                                                                        )?.icon
                                                                            }`}
                                                                        alt=""
                                                                    />
                                                                </div>
                                                                <div className="w-100">
                                                                    <div className="pdfName">
                                                                        {attachment?.replace(/^[^_]*_/, "")}
                                                                    </div>
                                                                    <div className="pdfFileSize">12 KB</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </>
                                            ) : (
                                                <div className="vidio_player mt-3" onClick={() => {
                                                    handleClickforpdf(attachment);
                                                }}>
                                                    <div className="d-flex pdfContainer gap-2 p-2 ">
                                                        <div className="d-flex align-items-center">
                                                            <img
                                                                className="extention_icon"
                                                                src={`${iconData?.find(
                                                                    (i) =>
                                                                        i.extension ===
                                                                        attachment?.match(/\.([^.]+)$/)[1]
                                                                )?.icon
                                                                    }`}
                                                                alt=""
                                                            />
                                                        </div>
                                                        <div className="w-100">
                                                            <div className="pdfName">
                                                                {attachment?.replace(/^[^_]*_/, "")}
                                                            </div>
                                                            <div className="pdfFileSize">12 KB</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )
                                )
                                : (<p className="noAttachment">No Attachment Found!!</p>)
                            }
                        </div>
                    </div>
                    <div className="link">
                        {noticeData?.embedded_link
                            ? (
                                <a
                                    className="link"
                                    href={
                                        noticeData?.embedded_link?.includes('http')
                                            ? noticeData?.embedded_link
                                            : `https://${noticeData?.embedded_link}`
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <p className="notice_Link text-break">
                                        {noticeData?.embedded_link}
                                    </p>
                                </a>
                            )
                            : null}
                    </div>
                </div>
            </div>
            {showPdfViewer && (
                <PdfViewer
                    closeMideaviewer={setShowPdfViewer}
                    attachment={responseAttach}
                />
            )}
            {isClicked &&
                (responseAttach.split(".").pop() === "mp4" || responseAttach.split(".").pop() === "MP4" ? (
                    <div className="fullSizeImg ">
                        <div className="SubfullSizeImg">
                            <video className="videoPlayer" controls>
                                <source src={IP + responseAttach.replace(/^\./, "")} type="video/mp4" />
                            </video>
                            <div>
                                <img
                                    className="crossIconImgQue"
                                    onClick={handleClick}
                                    src="/DCM-img/crossIcon.svg"
                                    alt="Up Arrow"
                                />
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="fullSizeImg ">
                        <div className="SubfullSizeImg">
                            {
                                !isError ? (
                                    <>
                                        <img
                                            className="imgMain"
                                            src={IP + responseAttach?.replace(/^\./, "")}
                                            alt="Full-size"
                                            onError={(e) => {
                                                setIsError(true)
                                            }}
                                        />
                                        <div>
                                            <img
                                                className="crossIconImgQue"
                                                onClick={handleClick}
                                                src="/images/cross.png"
                                                alt="Up Arrow"
                                            />
                                        </div>
                                    </>
                                ) : (
                                    <div className="fullSizeImg" style={{ display: "flex", flexDirection: "column" }}>
                                        <img
                                            onClick={() => {
                                                setIsError(false)
                                                handleClick()
                                            }}
                                            src="/images/cross.png"
                                            alt="Up Arrow"
                                            style={{ position: "absolute", top: "75px", right: "40%" }}
                                        />
                                        <img src="/images/no-photo1.png" alt="img" style={{ width: "25%" }} />
                                        <p style={{ color: "red", fontSize: "20px", fontWeight: "500", marginRight: "35px" }}>Error!! failed to load the requested file!</p>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                ))}
        </div>
    )
}

export default NoticeBoardPopUp